import {
    configureStore,
    combineSlices,
    EnhancedStore,
    Action,
} from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { isDevelopment } from './constants';

import { baseApiAuthenticated } from '@/api/v2';
import { authMiddleware } from '@/middleware/authMiddleware';
import { registerStore } from '@starjack/api';
import { authSlice } from '@starjack/features/authentication';
import { pageDataSlice } from '@starjack/features/pageData';
// The assistant is a separate service on its own host, so it cannot ride the
// Starjack API's base query. RTK Query middleware has to be registered when
// the store is created — there is no lazy path for it the way there is for
// reducers — which is why this one import is explicit.
import { assistantApi } from '@starjack/entities/assistantConfig';

export const rootReducer = combineSlices(
    baseApiAuthenticated,
    authSlice,
    pageDataSlice,
    assistantApi
);

// Wrap with clearAuthData logic
const finalReducer = (state, action) => {
    if (action.type === 'authSlice/clearAuthData') {
        return {
            ...rootReducer(undefined, action),
        };
    }

    return rootReducer(state, action);
};

export type Store = NonNullable<Parameters<typeof rootReducer>[0]>;

export type AppThunk = ThunkAction<void, Store, unknown, Action<string>>; // ThunkAction<void, Store, unknown, Action<string>>;

// eslint-disable-next-line
export const store: EnhancedStore<Store, any, any> = configureStore({
    reducer: finalReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }).concat(
            authMiddleware,
            baseApiAuthenticated.middleware,
            assistantApi.middleware
        ),

    devTools: isDevelopment,
});

// fetchAuthWrapper reads the token from here
registerStore(store);
